module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlistados-usuarios/adminlistados-usuarios.component.scss
// module id = ./src/app/adminlistados-usuarios/adminlistados-usuarios.component.scss
// module chunks = main